import { HomeFilled } from "@ant-design/icons";
import styled from "@emotion/styled";
import { Breadcrumb } from "antd";
import { useEffect, useState } from "react";
import { Props } from "../entity/props.entity";

interface BreadEntity {
	title?: string;
	link?: string;
}

export const Bread = (props: Props) => {
	const [arr, setArr] = useState<BreadEntity[]>([]);

	useEffect(() => {
		setArr(props.value ?? [{ title: "首页" }]);
	}, [props]);

	return (
		<Container>
			<div className='bread'>
				<Breadcrumb>
					<Breadcrumb.Item href='/'>
						<HomeFilled style={{ color: "#004885" }} />
					</Breadcrumb.Item>
					{arr &&
						arr.map((item, index) => {
							return item.link ? (
								<Breadcrumb.Item href={item.link ?? ""} key={index}>
									<span>{item.title}</span>
								</Breadcrumb.Item>
							) : (
								<Breadcrumb.Item key={index}>{item.title}</Breadcrumb.Item>
							);
						})}
				</Breadcrumb>
			</div>
		</Container>
	);
};
const Container = styled.div`
	width: 100%;

	.bread {
		margin: 2rem 0;
		border: 1px solid #e9eae9;
		border-radius: 0;
		padding: 1rem;
		list-style: none;
		background-color: transparent;

		svg {
			margin-top: -6px;
		}

		.blue-link {
			color: rgb(0, 72, 133);
		}
	}
`;
